import type { CartItem } from "./edit-cart"
import { pickTextTarget, elementText } from "./pick-text-target"

/**
 * Re-find the DOM node a staged cart item was originally picked from. The cart
 * survives a refresh in localStorage but the in-memory key→node map does not, so
 * on a reload staged edits would stop previewing and couldn't be re-opened by
 * clicking the element. CMS items match their `data-cms-*` stamp; intl items
 * match the rendered original text for the page's locale. (AHD-7396)
 */
export function locateCartNode(
  item: CartItem,
  locale: string,
  root: Document | HTMLElement = document
): HTMLElement | null {
  if (item.source === "cms" && item.cms) {
    const loc = Object.keys(item.values)[0] ?? locale
    const sel =
      `[data-cms-collection="${CSS.escape(item.cms.collection)}"]` +
      `[data-cms-id="${CSS.escape(item.cms.id)}"]` +
      `[data-cms-field="${CSS.escape(item.cms.field)}"]` +
      `[data-cms-locale="${CSS.escape(loc)}"]`
    return root.querySelector<HTMLElement>(sel)
  }
  const old = (
    item.values[locale] ?? Object.values(item.values)[0]
  )?.old?.trim()
  if (!old) return null
  const match = Array.from(
    root.querySelectorAll<HTMLElement>(
      "p,h1,h2,h3,h4,h5,h6,span,a,li,button,strong,em,label,div"
    )
  ).find(
    (el) => !el.closest("[data-ahead-editor-ui]") && elementText(el) === old
  )
  return match ? pickTextTarget(match) : null
}
